import { render, staticRenderFns } from "./stu_dangan_zt.vue?vue&type=template&id=54bcec07"
import script from "./stu_dangan_zt.vue?vue&type=script&lang=js"
export * from "./stu_dangan_zt.vue?vue&type=script&lang=js"
import style0 from "./stu_dangan_zt.vue?vue&type=style&index=0&id=54bcec07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports